/**
 * Central config for committee members (name, faculty, photoUrl, intro).
 * Role lists define which members appear on each page and their title per context.
 */

export const COMMITTEE_MEMBERS = {
  PHILIP: {
    id: 'philip',
    name: 'LI Chun Hong, Philip',
    faculty: 'HKU Faculty of Architecture',
    photoUrl: '/asset/images/profiles/2526/Philip.jpeg',
  },
  HIN: {
    id: 'hin',
    name: 'NG Yui Hin, Hin',
    faculty: 'HKU Faculty of Social Sciences',
    photoUrl: '/asset/images/profiles/2526/Hin.jpeg',
  },
  IVAN: {
    id: 'ivan',
    name: 'Fan Chun Kiu, Ivan',
    faculty: 'HKU Faculty of Arts',
  },
  VINCENT: {
    id: 'vincent',
    name: 'LAM Kwok Ho, Vincent',
    faculty: 'HKU Li Ka Shing Faculty of Medicine',
    photoUrl: '/asset/images/profiles/2526/Vincent.jpg',
  },
  AVIAN: {
    id: 'avian',
    name: 'LAM Ting Him, Avian',
    faculty: 'HKU Faculty of Arts',
    photoUrl: '/asset/images/profiles/2526/Avian.jpg',
  },
  KIKI: {
    id: 'kiki',
    name: 'KONG Tsz Ki, Kiki',
    faculty: 'HKU Faculty of Arts',
    photoUrl: '/asset/images/profiles/2526/Kiki.JPG',
  },
  KELLY: {
    id: 'kelly',
    name: 'CHAN Cheuk Lam, Kelly',
    faculty: 'HKU Faculty of Social Sciences',
  },
  COLE: {
    id: 'cole',
    name: 'WONG Yu, Cole',
    faculty: 'HKU Faculty of Arts',
    photoUrl: '/asset/images/profiles/2526/Cole.jpeg',
  },
  ODO: {
    id: 'odo',
    name: 'TSE Sheung Hei, Odo',
    faculty: 'HKU Faculty of Arts',
  },
  CEDRIC: {
    id: 'cedric',
    name: 'YUM Wang Ngai, Cedric',
    faculty: 'HKBU Faculty of Arts and Social Sciences',
  },
  RICH: {
    id: 'rich',
    name: 'CHENG Lok Him, Rich',
    faculty: 'HKU Faculty of Social Sciences',
  },
  DARREN: {
    id: 'darren',
    name: 'Darren D. Guan',
    faculty: 'HKU Faculty of Social Sciences',
  },
  AMBER: {
    id: 'amber',
    name: 'WONG Seng Ying, Amber',
    faculty: 'HKU Faculty of Social Sciences',
  },
};

/** CORTEX – Organising Committee (order preserved) */
export const CORTEX_ORGANISING_COMMITTEE = [
  { key: 'PHILIP', title: 'Chairperson' },
  { key: 'HIN', title: 'Internal Vice-Chairperson & Acting External Vice-Chairperson' },
  { key: 'VINCENT', title: 'Financial Secretary' },
  { key: 'AVIAN', title: 'Academic Secretary' },
  { key: 'KIKI', title: 'Social Secretary' },
  { key: 'KELLY', title: 'Publicity Secretary' },
  { key: 'COLE', title: 'IT Secretary' },
];

/** TITAN – Executive Committee */
export const TITAN_EXECUTIVE_COMMITTEE = [
  { key: 'ODO', title: 'Supervisor' },
  { key: 'PHILIP', title: 'Administrative Director' },
  { key: 'HIN', title: 'Academic Director' },
  { key: 'VINCENT', title: 'Honorary Secretary-cum-Treasurer' },
];

/** JELTR – Editorial Board */
export const JELTR_EDITORIAL_BOARD = [
  { key: 'HIN', title: 'Editor-in-Chief' },
  { key: 'CEDRIC', title: 'Associate Editor' },
  { key: 'RICH', title: 'Associate Editor' },
  { key: 'DARREN', title: 'Copy Editor' },
  { key: 'AMBER', title: 'Copy Editor' },
];

/**
 * Map role entries to props for CommitteeMemberCard.
 * @param {Array<{ key: string, title: string }>} roleEntries
 * @returns {Array<{ title: string, name: string, faculty: string, photoUrl?: string, intro?: string }>}
 */
export const getCommitteeMembersWithRoles = (roleEntries) =>
  roleEntries
    .map(({ key, title }) => {
      const member = COMMITTEE_MEMBERS[key];
      if (!member) return null;
      return {
        title,
        name: member.name,
        faculty: member.faculty,
        ...(member.photoUrl && { photoUrl: member.photoUrl }),
        ...(member.intro && { intro: member.intro }),
      };
    })
    .filter(Boolean);
